import { sendUserIdToGoogleAnalytics } from 'lib/gtag';
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setLocalStorage,
} from 'lib/localStorage';
import { post } from 'lib/request';
import { parseToBool } from 'lib/string';

import LOCAL_STORAGE from 'constants/localStorage';

const {
  IS_POLICY_NUMBER_1_ACCEPTED,
  IS_POLICY_NUMBER_2_ACCEPTED,
  IS_POLICY_NUMBER_3_ACCEPTED,
  IS_POLICY_NUMBER_5_ACCEPTED,
  IS_SHOWING_LGPD_ALERT,
} = LOCAL_STORAGE;

const CONSENTS = [
  {
    consentId: 1,
    storeKey: LOCAL_STORAGE.IS_POLICY_NUMBER_1_ACCEPTED,
  },
  {
    consentId: 2,
    storeKey: LOCAL_STORAGE.IS_POLICY_NUMBER_2_ACCEPTED,
  },
  {
    consentId: 3,
    storeKey: LOCAL_STORAGE.IS_POLICY_NUMBER_3_ACCEPTED,
  },
  {
    consentId: 5,
    storeKey: LOCAL_STORAGE.IS_POLICY_NUMBER_5_ACCEPTED,
  },
];

const getLocalStoredConsents = () =>
  CONSENTS.map(({ consentId, storeKey }) => ({
    consentId,
    consentStatus: Number(getFromLocalStorage(storeKey)),
  }));

const postGiveLGPDConsents = async () => {
  const filteredConsents = getLocalStoredConsents().filter(
    ({ consentId }) => consentId > 3
  );

  return post('/consent', {
    body: filteredConsents,
  });
};

const resetLGPDConsentsStorage = () => {
  const LGPDConsentsLocalStorageKeys = [
    IS_POLICY_NUMBER_1_ACCEPTED,
    IS_POLICY_NUMBER_2_ACCEPTED,
    IS_POLICY_NUMBER_3_ACCEPTED,
    IS_POLICY_NUMBER_5_ACCEPTED,
    IS_SHOWING_LGPD_ALERT,
  ];

  LGPDConsentsLocalStorageKeys.forEach((LGPDConsentsLocalStorageKey) => {
    removeFromLocalStorage(LGPDConsentsLocalStorageKey);
  });
};

const saveLocalConsents = (consents) =>
  consents.forEach(({ consentId, consentStatus }) => {
    const { storeKey } = CONSENTS.find(
      (consent) => consentId === consent.consentId
    );

    setLocalStorage(storeKey, consentStatus);
  });

const verifyAndSendUserToAnalytics = (user) => {
  if (parseToBool(getFromLocalStorage(IS_POLICY_NUMBER_1_ACCEPTED))) {
    sendUserIdToGoogleAnalytics(user.userId);
  }
};

const useLGPDConsents = () => ({
  getLocalStoredConsents,
  saveLocalConsents,
  postGiveLGPDConsents,
  resetLGPDConsentsStorage,
  verifyAndSendUserToAnalytics,
});

export default useLGPDConsents;
